import { gql } from "@apollo/client";

const GET_TEXT_AT_POSITION = gql`
  query getTextAtPosition(
    $templateId: String!
    $clientIdentifier: String!
    $pageNumber: Int!
    $position: PositionInput!
  ) {
    invoiceInterpretation {
      getTextAtPosition(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        pageNumber: $pageNumber
        position: $position
      ) {
        position {
          bottomLeftX
          bottomLeftY
          topRightX
          topRightY
        }
        value
      }
    }
  }
`;

export default GET_TEXT_AT_POSITION;
